import { AfterContentInit, Component, ContentChildren, QueryList } from '@angular/core'
import { CheckoutAccordionTabComponent } from '../checkout-accordion-tab/checkout-accordion-tab.component'
import { CheckoutAccordionContentComponent } from '../checkout-accordion-content/checkout-accordion-content.component'

@Component({
    selector: 'mg-checkout-accordion',
    templateUrl: './checkout-accordion.component.html',
    styleUrls: ['./checkout-accordion.component.scss'],
})
export class CheckoutAccordionComponent implements AfterContentInit {
    @ContentChildren(CheckoutAccordionTabComponent)
    tabComponents: QueryList<CheckoutAccordionTabComponent>

    @ContentChildren(CheckoutAccordionContentComponent)
    contentComponents: QueryList<CheckoutAccordionContentComponent>

    activeTabIndex: number

    get lastTabActive() {
        return this.activeTabIndex === this.contentComponents.length - 1
    }

    get firstTabActive() {
        return this.activeTabIndex === 0
    }

    ngAfterContentInit() {
        this.determineActiveTab()
    }

    determineActiveTab() {
        if (!this.activeTabIndex) {
            this.activeTabIndex = 0
        }
        this.activateTabIndex(this.activeTabIndex)
    }

    activateNextTab() {
        if (!this.lastTabActive) {
            this.activateTabIndex(this.activeTabIndex + 1)
        }
    }

    activatePreviousTab() {
        if (!this.firstTabActive) {
            this.activateTabIndex(this.activeTabIndex - 1)
        }
    }

    activateTabIndex(tabIndex) {
        this.activeTabIndex = tabIndex
        this.tabComponents.forEach((tab, index) => (tab.isActive = tabIndex === index))
        this.contentComponents.forEach((tab, index) => (tab.isActive = tabIndex === index))
    }
}
